import { Injectable } from '@angular/core';
import { CanActivate, Router, Route, CanLoad } from '@angular/router';
import { AuthService } from './services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ManagerGuard implements CanActivate, CanLoad {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const canAccess = await this.authService.canAccessDashboard();
    if (!canAccess) {
      this.router.navigateByUrl('/login');
    }
    return canAccess;
  }

  async canLoad(route: Route): Promise<boolean> {
    const canAccess = await this.authService.canAccessDashboard();
    if (!canAccess) {
      this.router.navigateByUrl('/login');
    }
    return canAccess;
  }
}
